import TsaHandlerInfoVerify from '@/components/handlerInfoVerify/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const HandlerInfoVerify = vue.extend(TsaHandlerInfoVerify)
    if (!$vm) {
      $vm = new HandlerInfoVerify({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const handlerInfoVerify = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaHandlerInfoVerify) {
      vue.prototype.$TsaHandlerInfoVerify = handlerInfoVerify
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/handlerInfoVerify/index.js